// @ts-ignore
import * as Alert from './Alert';

export default Alert;
